import dayjs from "dayjs";
import { createContext, useEffect, useState } from "react";
import axios from "axios";

// export const urlToggle = "http://220.71.168.243:9090";
export const urlToggle = "";
const DataContext = createContext({});
export const DataProvider = ({ children }) => {
  const today = dayjs();
  const oneWeekAgo = new Date();
  oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
  const formattedOneWeekAgo = oneWeekAgo.toISOString().slice(0, 10);
  // 대기
  const [myData, setMyData] = useState([]);
  const [airForeData, setAirForeData] = useState([]);
  const [spotData, setSpotData] = useState([]);
  const [airNode, setAirNode] = useState("383"); //주소 기본값:

  // 악취
  const [stinkData, setStinkData] = useState([]);
  const [stinkNode, setStinkNode] = useState("24"); //주소 기본값: 동방회관
  // const [stdate, setStdate] = useState(formattedOneWeekAgo);
  // const [eddate, setEddate] = useState(dayjs().format("YYYY-MM-DD")); // 당일
  // 악취민원신고+조회
  const [odorReports, setOdorReports] = useState([]);

  const [addr, setAddr] = useState([]); //민원조회 주소
  const [positionXY, setPositionXY] = useState([]);
  const [minwonSpot, setMinwonSpot] = useState(0); // 민원 기본값:

  const [pageno, setPageno] = useState(1);
  const [totalCount, setTotalCount] = useState("");
  const [pageLength, setPageLength] = useState(0);

  const [stdate, setStdate] = useState(formattedOneWeekAgo);
  const [eddate, setEddate] = useState(new Date().toISOString().slice(0, 10));

  const [selectedSensor, setSelectedSensor] = useState("복합악취");
  // 악취 전체데이터(지도)
  const [stinkMapData, setStinkMapData] = useState([]);
  const getStinkMap = async () => {
    try {
      const response = await axios.get(
        `${urlToggle}/odor/mobile_odor_api/odorStatInfos`
      );
      const stinkMap = response.data.result;

      // 가공된 데이터를 담을 배열들
      let smell01 = [];
      let smell02 = [];
      let smell03 = [];
      let smell04 = [];

      // 데이터를 가공하여 각각의 배열에 추가
      for (let i = 0; i < stinkMap?.length; i++) {
        // 데이터 가공 및 각각의 배열에 추가 로직 작성

        // 예시로 각각의 배열에 추가하는 로직
        smell01.push(
          stinkMap[i]?.items.filter(
            (item) => item.sensor_name_kor === "복합악취"
          )
        );
        smell02.push(
          stinkMap[i]?.items.filter(
            (item) => item.sensor_name_kor === "황화수소"
          )
        );
        smell03.push(
          stinkMap[i]?.items.filter(
            (item) => item.sensor_name_kor === "암모니아"
          )
        );
        smell04.push(
          stinkMap[i]?.items.filter(
            (item) => item.sensor_name_kor === "총휘발성유기화합물"
          )
        );
      }

      return setStinkMapData(stinkMap);
    } catch (err) {
      console.error(err);
    }
  };
  // 악취
  const getStinkData = async () => {
    try {
      const response = await axios.get(
        `${urlToggle}/odor/mobile_odor_api/odorInfos?sys_net_node_id=${stinkNode}`
      );
      const stinReskData = response.data.result;
      setStinkData(stinReskData);
    } catch (err) {
      console.error(err);
    }
  };

  console.log(stinkNode);

  useEffect(() => {
    try {
      getStinkData();
    } catch (err) {
      console.error("Error fetching data:", err);
    }
  }, [stinkNode]);

  const posToAddr = async () => {
    if (positionXY.length > 0) {
      const baseurl = `${urlToggle}/odor/mobile_odor_api/posToAddr`;
      const params = {
        // 필요한 query params를 {} 형태에 담아준다.
        xpos: positionXY[0],
        ypos: positionXY[1],
      };
      const queryString = new URLSearchParams(params).toString(); // url에 쓰기 적합한 querySting으로 return 해준다.
      const requrl = `${baseurl}?${queryString}`; // 완성된 요청 url.

      try {
        await fetch(requrl)
          .then((res) => {
            return res.json();
          })
          .then((json) => {
            setAddr(json.result[0].bjdnm + json.result[0].bon);
          });
      } catch (error) {
        // console.log(error);
      }
    }
  };

  useEffect(() => {
    posToAddr();
  }, [positionXY]);

  //악취민원신고조회
  const getOdorReports = async (stdate, eddate, pageno) => {
    try {
      const response = await fetch(
        `${urlToggle}/odor/mobile_odor_api/odorReports?stdate=${stdate}&eddate=${eddate}&pageno=${pageno}&rowcount=1000`,
        {
          method: "GET",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );
      if (response.ok) {
        const data = await response.json();

        if (data.result && data.result.length > 0) {
          // 데이터가 존재하는 경우
          setOdorReports(data.result);
          setTotalCount(data.totCount);
          setPageLength(data.rowLength);
        } else {
          // 데이터가 없는 경우
          // console.log("데이터가 없습니다.");
          setOdorReports([]); // [] 값을 설정하여 데이터를 초기화
          setTotalCount(0); // 다른 관련된 상태 변수도 초기화
          setPageLength(0);
        }
      } else {
        console.error("Error fetching data:", response.statusText);
      }
    } catch (err) {
      console.error("Error fetching data:", err);
    }
  };

  useEffect(() => {
    try {
      //getForeData();
      // getSpotData();
      getOdorReports(stdate, eddate, pageno);
    } catch (err) {
      console.error("Error fetching data:", err);
    }
  }, [stdate, eddate, pageno]);

  //악취신고 관리자 버전 체인지 훅
  const [adminChange, setAdminChange] = useState(false);

  const [address, setAddress] = useState(""); //주소
  const [userName, setUserName] = useState(""); //사용자이름
  const [userPhone, setUserPhone] = useState(0); //전화번호
  const [smellDate, setSmellDate] = useState(""); //악취신고날짜
  const [smellLev, setSmellLev] = useState(0); //악취강도
  const [smellType, setSmellType] = useState(""); //악취종류
  const [content, setContent] = useState(""); //비고란

  const [answer, setAnswer] = useState(""); //조취결과
  const [pwdCheck, setPwdCheck] = useState(""); //회원 패스워드 체크
  const [phoneCheck, setPhoneCheck] = useState(""); //회원전화번호

  //악취신고 테이블별 데이터 가져오는 함수
  const [editId, setEditId] = useState(0);
  const GetEditId = async (id) => {
    for (let list of odorReports) {
      if (list.seqno === id) {
        setAddress(list.report_addr);
        setUserName(list.report_nm);
        setUserPhone(list.report_mob_num);
        setSmellDate(list.datetime);
        setSmellLev(list.stink_levelnm);
        setSmellType(list.stink_div);
        setContent(list.bigo);
      }
    }
    setEditId(id);
  };

  const [adminReportsDetail, setAdminReportsDetail] = useState([]);

  useEffect(() => {
    AdminOrderReportOnSubmit();
  }, [editId]);

  const AdminOrderReportOnSubmit = async () => {
    const res = await axios.get(
      `${urlToggle}/odor/mobile_odor_api/odorReportSelectAdmin?seqno=${editId}`
    );
    const adminSubmitRes = res.data.result;
    setAdminReportsDetail(adminSubmitRes);
  };

  //사용자 회원조회

  const [usrPhoneCheck, setUsrPhoneCheck] = useState("");
  const [userPwdCheck, setUserPwdCheck] = useState("");
  const [checkList, setCheckList] = useState([]);

  const UserSecretCheck = async () => {
    const res = await axios.get(
      `${urlToggle}/odor/mobile_odor_api/odorReportSelectPwd?report_password=${userPwdCheck}&report_mob_num=${usrPhoneCheck}&seqno=${seqno}`
    );
    const usercheckRes = res.data.result;
    setCheckList(usercheckRes);
  };

  useEffect(() => {
    UserSecretCheck();
  }, [userPwdCheck]);

  //회원인증 -> 사용자ver. 관리자 답변 조회
  const [seqno, setSeqno] = useState(0);
  const [num, setNum] = useState(0);
  const [answerList, setAnswerList] = useState({});

  const AdminAnswerDetailList = async () => {
    const res = await axios.get(
      `${urlToggle}/odor/mobile_odor_api/odorReportSelectAdmin?seqno=${num}`
    );
    const detailRes = res.data.result;
    setAnswerList(detailRes);
  };

  useEffect(() => {
    AdminAnswerDetailList();
  }, [seqno]);

  //관리자 답변 남기기
  const [adminReply1, setAdminReply1] = useState("");
  const [adminReply2, setAdminReply2] = useState("");
  const [adminReply3, setAdminReply3] = useState("");
  const [replyId, setReplyId] = useState(0);

  const AdminReplyOnSubmit = async () => {
    await axios.post(
      `${urlToggle}/odor/mobile_odor_api/odorReportReplyAdmin`,
      {
        seqno: replyId,
        report_reply1: adminReply1,
        report_reply2: adminReply2,
        report_reply3: adminReply3,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );
    UserSecretCheck();
    setAdminReply1("");
    setAdminReply2("");
    setAdminReply3("");
    setReplyId(0);
  };

  // 기기 접속 확인
  const [dmData, setDmData] = useState([]);
  const getSearch = async () => {
    try {
      const response = await axios.post(
        `${urlToggle}/odor/api/log/insert/device`,
        {
          log_div: "dm",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );
      const mobileData = response.data.data;
      setDmData(mobileData);
    } catch (error) {
      console.error("Error fetching average data:", error);
      setDmData([]);
    }
  };

  useEffect(() => {
    getSearch();
    getStinkMap();
  }, []);

  return (
    <DataContext.Provider
      value={{
        //관리자 -> 답변등록
        adminReply1,
        adminReply2,
        adminReply3,
        setAdminReply1,
        setAdminReply2,
        setAdminReply3,
        replyId,
        setReplyId,
        AdminReplyOnSubmit,

        num,
        setNum,

        //사용자 비밀번호 & 휴대폰번호 확인절차
        adminChange,
        setAdminChange,
        GetEditId,
        pwdCheck,
        setPwdCheck,
        phoneCheck,
        setPhoneCheck,
        // 비번&휴대폰번호 인증-> 인증된데이터표출
        seqno,
        setSeqno,
        answerList,
        setAnswerList,

        //관리자버전 디테일 내용조회
        adminReportsDetail,

        address,
        setAddress,
        userName,
        setUserName,
        userPhone,
        setUserPhone,
        smellDate,
        setSmellDate,
        smellLev,
        setSmellLev,
        smellType,
        setSmellType,
        content,
        setContent,
        answer,
        setAnswer,

        odorReports,
        setOdorReports,
        spotData,
        setSpotData,
        stdate,
        setStdate,
        eddate,
        setEddate,
        myData,
        setMyData,
        stinkData,
        pageno,
        setPageno,
        totalCount,
        setTotalCount,
        pageLength,
        setPageLength,
        addr,
        setAddr,
        setAirNode,
        setStinkNode,
        positionXY,
        setPositionXY,
        getOdorReports,
        minwonSpot,
        setMinwonSpot,

        //사용자확인
        usrPhoneCheck,
        setUsrPhoneCheck,
        userPwdCheck,
        setUserPwdCheck,
        checkList,
        setCheckList,

        UserSecretCheck,

        dmData,
        setDmData,

        getStinkMap,
        stinkMapData,
        setStinkMapData,

        selectedSensor,
        setSelectedSensor,
      }}
    >
      {children}
    </DataContext.Provider>
  );
};

export default DataContext;
